module.exports = __webpack_public_path__ + "static/media/bisag-n.2b459656.jpg";